import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";

type AiPlanActiveSwitchProps = Readonly<{
  checked: boolean;
  /** When true, switch is locked (no manage privilege). */
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}>;

const disabledSwitchSx = {
  "& .MuiSwitch-switchBase.Mui-disabled": {
    color: "#F3F4F6",
  },
  "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
    color: "#6690F5",
  },
  "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
    backgroundColor: "#BFC5CE",
    opacity: 1,
  },
  "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
    backgroundColor: "#E8EEFF",
    opacity: 1,
  },
};

export default function AiPlanActiveSwitch({
  checked,
  disabled = false,
  onChange,
}: AiPlanActiveSwitchProps) {
  const switchControl = (
    <Switch
      size="small"
      color="primary"
      checked={checked}
      disabled={disabled}
      onChange={(event) => {
        event.stopPropagation();
        if (disabled) return;
        onChange(event.target.checked);
      }}
      onClick={(event) => event.stopPropagation()}
      sx={disabled ? disabledSwitchSx : undefined}
      inputProps={{ "aria-label": "Active" }}
    />
  );

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      {disabled ? (
        <Tooltip title="No permission">
          <Box
            component="span"
            data-testid="ai-plan-active-switch-locked"
            sx={{ display: "inline-flex", cursor: "not-allowed" }}
          >
            {switchControl}
          </Box>
        </Tooltip>
      ) : (
        switchControl
      )}
    </Box>
  );
}
